export const Permissions = {
  users: {
    create: "users:create",
    read: "users:read",
    update: "users:update",
    delete: "users:delete",
    ban: "users:ban",
  },
  geo: {
    create: "geo:create",
    read: "geo:read",
    update: "geo:update",
    delete: "geo:delete",
  },
  shipping: {
    create: "shipping:create",
    read: "shipping:read",
    update: "shipping:update",
    delete: "shipping:delete",
  },
  options: {
    create: "options:create",
    read: "options:read",
    update: "options:update",
    delete: "options:delete",
  },
  catalog: {
    create: "catalog:create",
    read: "catalog:read",
    update: "catalog:update",
    delete: "catalog:delete",
  },
  orders: {
    read: "orders:read",
    update: "orders:update",
  },
  payments: {
    read: "payments:read",
    refund: "payments:refund",
  },
  customers: {
    read: "customers:read",
    create: "customers:create",
    update: "customers:update",
    delete: "customers:delete",
  },
  inventory: {
    create: "inventory:create",
    read: "inventory:read",
    update: "inventory:update",
    delete: "inventory:delete",
  },
  reviews: {
    read: "reviews:read",
    update: "reviews:update",
    delete: "reviews:delete",
  },
  cms: {
    create: "cms:create",
    read: "cms:read",
    update: "cms:update",
    delete: "cms:delete",
  },
  settings: {
    read: "settings:read",
    update: "settings:update",
  },
  pos: {
    checkout: "pos:checkout",
  },
  social_sources: {
    read: "social_sources:read",
    create: "social_sources:create",
    update: "social_sources:update",
  },
} as const;

export const ALL_PERMISSIONS = Object.entries(Permissions).flatMap(
  ([resource, actions]) =>
    Object.entries(actions).map(([action, id]) => ({ id, resource, action })),
);

export type PermissionId = (typeof ALL_PERMISSIONS)[number]["id"];

// Human-friendly labels for rendering in UI
export const RESOURCE_LABELS: Record<string, string> = {
  users: "ຜູ້ໃຊ້",
  geo: "ພູມິສາດ",
  shipping: "ຄ່າສົ່ງ",
  options: "ຕົວເລືອກສິນຄ້າ",
  catalog: "ແຄັດຕາລອກ",
  orders: "ຄຳສັ່ງຊື້",
  payments: "ການຊຳລະ",
  customers: "ລູກຄ້າ",
  inventory: "ສາງສິນຄ້າ",
  reviews: "ຄຳເຫັນສິນຄ້າ",
  cms: "ເນື້ອຫາ (CMS)",
  settings: "ຕັ້ງຄ່າ",
  pos: "POS",
  social_sources: "ແຫຼ່ງຂາຍ Social Media",
};

export const ACTION_LABELS: Record<string, string> = {
  create: "ສ້າງ",
  read: "ເບິ່ງ",
  update: "ແກ້ໄຂ",
  delete: "ລຶບ",
  ban: "ລະງັບ",
  all: "ທັງໝົດ",
  refund: "ຄືນເງິນ",
  checkout: "ຊຳລະທີ່ເຄົາເຕີ",
};

export function getResourceLabel(resource: string): string {
  return RESOURCE_LABELS[resource] ?? resource;
}

export function getActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

export function getPermissionLabel(id: PermissionId): string {
  const [resource, action] = (id as string).split(":");
  return `${getActionLabel(action ?? "")} ${getResourceLabel(resource ?? "")}`;
}

export function getPermissionLabels(ids: PermissionId[]): string[] {
  return ids.map((id) => getPermissionLabel(id));
}
